import { env } from '~/config/env';

export const LANDING_QUESTION_COUNT = env.VITE_APP === 'usmle' ? 2500 : 1700;
